import { submitForm } from 'app/schema-form/actions';
import { connect } from 'react-redux';
import { createPublishTarget } from '../../actions.js';
import CreatePublishTarget from './create-publish-target.jsx';

export default connect(null, { createPublishTarget, submitForm })(CreatePublishTarget);
export { default as formReducer } from './reducer.js';
